// extracted by mini-css-extract-plugin
export default {"clickableList":"XfWwgbCwb21lCITMg7Fm","selected":"bDg7vzkzh1zvTgJRHtzm"};